import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

import LiveBidsCarousel from '../../components/LiveBidsCarousel/LiveBidsCarousel';
import { 
  liveBidsListingsSelector, 
  liveBidsInProgressSelector, 
  liveBidsErrorSelector,
  liveBidsNeedsRefreshSelector 
} from '../../components/LiveBidsCarousel/LiveBidsCarousel.duck';
import { fetchLiveBidsListings } from '../../components/LiveBidsCarousel/LiveBidsCarousel.duck';

const LiveBidsCarouselContainer = props => {
  const { liveBidsListings, liveBidsInProgress, liveBidsError, needsRefresh, onFetchLiveBidsListings } = props;
  const history = useHistory();

  // Fetch data on mount if not cached, or when page regains focus if data is stale
  useEffect(() => {
    if (needsRefresh) {
      onFetchLiveBidsListings();
    }
  }, [needsRefresh, onFetchLiveBidsListings]);

  // Refresh when page regains focus (only if data is stale)
  useEffect(() => {
    const handleFocus = () => {
      if (needsRefresh) {
        onFetchLiveBidsListings();
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [needsRefresh, onFetchLiveBidsListings]);

  const handleViewAllBids = () => {
    // Navigate to dedicated live bids page
    history.push('/live-bids-search');
  };

  return (
    <LiveBidsCarousel
      listings={liveBidsListings}
      inProgress={liveBidsInProgress}
      error={liveBidsError}
      onViewAllBids={handleViewAllBids}
    />
  );
};

const mapStateToProps = state => ({
  liveBidsListings: liveBidsListingsSelector(state),
  liveBidsInProgress: liveBidsInProgressSelector(state),
  liveBidsError: liveBidsErrorSelector(state),
  needsRefresh: liveBidsNeedsRefreshSelector(state),
});

const mapDispatchToProps = dispatch => ({
  onFetchLiveBidsListings: () => dispatch(fetchLiveBidsListings()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(LiveBidsCarouselContainer);
